import React, { useRef } from 'react'
import Scrollspy from 'react-scrollspy'
import { useRouter } from 'next/router'
import { useLayoutEffect } from 'components/common'
import cx from 'classnames'

import s from './ScrollSpyMenu.module.css'
import Dropdown from 'components/common/Dropdown/Dropdown'

const ScrollSpyMenu = ({
  scrollSpyItems,
  slicedShownItems,
  slicedDropdownItems,
  pageOffset,
  activeSection = ''
}) => {
  const router = useRouter()

  const scrollSpyRef = useRef()

  useLayoutEffect(() => {
    if (pageOffset > 720) {
      scrollSpyRef.current.classList.add(s.fixedMenu)
    } else {
      if (scrollSpyRef.current.classList.length === 2) {
        scrollSpyRef.current.classList.remove(s.fixedMenu)
      }
    }
  }, [pageOffset])

  const restaurantId = router.query.restaurantId || ''

  return (
    <div className={s.categoryList} ref={scrollSpyRef}>
      <Scrollspy
        items={scrollSpyItems}
        className={s.scrollSpy}
        offset={-300}
        currentClassName={s.categoryListActive}
      >
        {slicedShownItems.map((category, index) => (
          <li
            key={`c-${index}`}
            onClick={() =>
              router.replace(`/biz/${restaurantId}/#section${index}`)
            }
          >
            <div className={s.categoryName}>{category.name}</div>
          </li>
        ))}

        {!!slicedDropdownItems.length && (
          <Dropdown>
            {slicedDropdownItems.map((item, index) => (
              <li
                className={s.dropdownItem}
                key={`${item.name}-${index}`}
                onClick={() =>
                  router.replace(
                    `/biz/${restaurantId}/#section${
                      index + slicedShownItems.length
                    }`
                  )
                }
              >
                <div
                  className={cx({
                    [s['activeDropdown']]:
                      `#section${index + slicedShownItems.length}` ===
                      activeSection
                  })}
                >
                  {item.name}
                </div>
              </li>
            ))}
          </Dropdown>
        )}
      </Scrollspy>
    </div>
  )
}

export default ScrollSpyMenu
